import React from 'react'
import InputEdit from '../../miscellaneous/InputEdit/InputEdit'

const KmlComponent = (props) => {
  const { indicador } = props
  console.log('props', props)
  const getMetaXyear = year => {
    return Math.round(100 * props.indicador.reportes.filter(f => f.anualidad === year).reduce((pre, cur) => pre + cur.value, 0)) / 100
  }
  return (
    <>
      <div style={{ minHeight: '205px' }}>
        <div className="modal-title-header">
          <div className='title-modal-kml-input no-select'>Ver Reportes</div>
          <div className='add-button'><i className="fas fa-times on-mouse-hover" onClick={props.close}></i></div>
        </div>
        <div >
          <div className='add-reporte-info' style={{marginBottom:'10px'}}>
            <div className='text-information-report'>
              <label>Linea</label>
              <p>{indicador.linea}</p>
            </div>
            <div className='text-information-report'>
              <label>Indicador</label>
              <p>{indicador.indicador}</p>
            </div>
            <div className='flex-space-arround'>
              <div className='text-information-report'>
                <label>Peso</label>
                <p>{indicador['refPisccNivelAlcance.nivel']}</p>
              </div>
              <div className='text-information-report'>
                <label>Nivel Alcance (Alcance)</label>
                <p>{props.vectors.nivelAlcance.filter(f => indicador.refPisccNivelAlcanceId === f.id).reduce((pre, cur) => cur.text, '')}</p>
              </div>
              <div className='text-information-report'>
                <label>Unidad</label>
                <p>{indicador.unidad}</p>
              </div>
            </div>
            <div className='flex-space-arround'>
              <div className='text-information-report'>
                <label>Meta 2020</label>
                <p>{getMetaXyear(2020).toString() + ' - ' + indicador.meta1}</p>
              </div>
              <div className='text-information-report'>
                <label>Meta 2021</label>
                <p>{getMetaXyear(2021).toString() + ' - ' + indicador.meta2}</p>
              </div>
              <div className='text-information-report'>
                <label>Meta 2022</label>
                <p>{getMetaXyear(2022).toString() + ' - ' + indicador.meta3}</p>
              </div>
              <div className='text-information-report'>
                <label>Meta 2023</label>
                <p>{getMetaXyear(2023).toString() + ' - ' + indicador.meta4}</p>
              </div>
            </div>
            <table className="table-results-reports">
              <thead>
                <tr>
                  <th></th>
                  <th>Texto</th>
                  <th>Anualidad</th>
                  <th>Fecha</th>
                  <th>Valor</th>
                  <th>Archivos</th>
                </tr>
              </thead>
              <tbody>
                {
                  props.reports.map(item => (
                    <tr key={'row-table-watch-rep-' + item.id}>
                      <td>
                        <i onClick={() => props.deleteReport(item.id)} className='fas fa-trash-alt' style={{ color: 'red' }} title='Eliminar reporte'></i>
                      </td>
                      <td className="no-select pointer" onDoubleClick={() => props.dobleClick('editText', item.id)}>
                        {
                          item.editText ?
                            <InputEdit
                              // small={true}
                              text={item.texto}
                              onAccept={(id, text) => props.editReport(id, 'texto', text)}
                              onCancel={(id) => props.dobleClick('editText', id)}
                              id={item.id}
                            /> :
                            item.texto
                        }
                      </td>
                      <td>{item.anualidad}</td>
                      <td>{item.fecha.split('T')[0]}</td>
                      <td className="no-select pointer" onDoubleClick={() => props.dobleClick('editValue', item.id)}>
                        {
                          item.editValue ?
                            <InputEdit
                              small={true}
                              text={item.value}
                              onAccept={(id, text) => props.editReport(id, 'value', text)}
                              onCancel={(id) => props.dobleClick('editValue', id)}
                              id={item.id}
                            /> :
                            item.value
                        }
                      </td>
                      <td>
                        <div style={{ maxHeight: '60px', overflow: 'auto' }}>
                          {
                            item.files.map((file, i) => <React.Fragment key={`key-file-watch-report-${i}`}><a href={file['pisccArchivoReportes.url']}>{file['pisccArchivoReportes.name']}</a><br /></React.Fragment>)
                          }
                        </div>
                      </td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  )
}

export default KmlComponent;